// extracted by mini-css-extract-plugin
module.exports = {"block":"style__block__GqhMb","code":"style__code__cS4i-","codeEditorTextarea":"style__codeEditorTextarea__r-x-U"};